import { render, staticRenderFns } from "./FreightDetail.vue?vue&type=template&id=12ec8c15"
import script from "./FreightDetail.vue?vue&type=script&lang=js"
export * from "./FreightDetail.vue?vue&type=script&lang=js"
import style0 from "./FreightDetail.vue?vue&type=style&index=0&id=12ec8c15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports